import axios from "axios";
import $ from 'jquery';
import { isChrome as chrome,isMobile as mobileTab,isMobileOnly as omobile,isTablet as tablete,isBrowser as browser,isSmartTV as smarttv,isWearable as wearable,isAndroid as android,isWinPhone as winphone,isIOS as ios,isFirefox as ff,isSafari as safari,isOpera as opera,isIE as ie,isEdge as edge,isYandex as yandex,isChromium as chromium,isMobileSafari as mobsafari,osVersion as version,osName as osname,fullBrowserVersion as fbrowserversion,browserVersion as browserVer,browserName as browserName,mobileVendor as mobvendor,mobileModel as mobmodel,engineName as engName,engineVersion as engversion,getUA as getua,deviceType as deviceType,isIOS13 as ios13,isIPhone13 as iphone13,isIPad13 as ipad13,isIPod13 as ipod13,isElectron as isElectron,deviceDetect as devicedetect} from "react-device-detect";


const channelCheckUser = function(data)
{
	console.log('stat #1');
	if ( typeof data !== 'undefined' )
	  {
		  console.log('stat #2');
			if ( data && data['memberExpire'] && this.state.chosenSession['sessionProperty'] === 1 )
				{
					$("#memberExpired").attr({'style':'display:block'});
					this.setState({ email: "" });
					this.closeLogin();
					$('.main_loader').hide();
					console.log('stat #3');
					return false;
				}
			
			if ( data && data['privateMember'] === "no" && this.state.chosenSession['sessionProperty'] === 1 )
				{
					$("#existingUserModel").attr({'style':'display:block'});
					this.setState({ email: "" });
					this.closeLogin();
					$('.main_loader').hide();
					console.log('stat #4');
					return false;
				}
			if ( data && data.sameSessionExist === 'Yes' && this.state.redirect === 'Sign Up' )
				{
					$("#exist_session").attr({'style':'display:block'});
					this.setState({
							  loginUserName: data.firstName
							})
					this.closeLogin();
					$('.main_loader').hide();
					console.log('stat #5');
					return false;
				}
			
			if ( data && data.sameSessionExist === 'Yes' )
				{
					// Use already existing in class, login
					
					this.setState({
								  isOpenLoginAll: true
								});
					$('.main_loader').hide();	
					console.log('stat #6');
					return false;
				}
			else if ( ( this.state.chosenSession.shoppingList && this.state.chosenSession.shoppingList.length ) > 0 || ( this.state.chosenSession.equipmentList && this.state.chosenSession.equipmentList.length > 0 ) || this.state.chosenSession.parentRecrId != null )
				{
					let currentURL = window.location.href; 
					localStorage.setItem("channelEmail", this.state.email);
					localStorage.setItem("chanelRedirect", this.state.redirect);
					var jsonAdd = {'email': this.state.email};
					if ( this.state.redirect === 'Sign Up' ) { localStorage.setItem("backToChannel", currentURL); jsonAdd['backToChannel'] = currentURL; }
					
					var addondata = btoa(JSON.stringify(jsonAdd));
					console.log('stat #7');
					
					window.location.href = this.state.chosenSession.sessionLink + '?' + addondata;
					return false;  
				}
			
			let object = data;
			if ( this.state.redirect !== 'Host' )
				{
					console.log('stat #8');
						if ( !$.isEmptyObject(object) && object && object !== null && object['id'] )
							{
								if ( this.state.allAboutSession.sessionChargeAllowed != 1 )
									{
										this.setState({
										  isOpenLoginAll: true
										});
									}
								else
									{
										console.log('THISSSSSSSSSSSSS');
										
										let member = 1 ? data.privateMember == 'yes' : 0;
										let pickedSessions = [{
																'chargeForSession': this.state.chosenSession.chargeForSession,
																'chargeForSessionNonMember': this.state.chosenSession.chargeForSessionNonMember,
																'duration': this.state.chosenSession.duration,
																'externFormatDate': this.state.chosenSession.sessionStartTime,
																'hostFullName': this.state.chosenSession.hostBy.firstName+' '+this.state.chosenSession.hostBy.lastName,
																'id': this.state.chosenSession.id,
																'isCompleted': this.state.chosenSession.isCompleted,
																'scheduleDate': this.state.chosenSession.scheduleDate,
																'sdFormateDate': '',
																'sessionEndDate': this.state.chosenSession.sessionEndDate,
																'sessionProperty': this.state.chosenSession.sessionProperty
															}];
										let fcfs = this.calculatePrice( member, pickedSessions);
										this.setState({
												isChargingSessionIncluded: true,
												chargeForSession: fcfs, 
												finalChargeForSession: fcfs,
												sessionHostFirstName: this.state.allAboutSession.hostBy.firstName,
												sessionHostLastName: this.state.allAboutSession.hostBy.lastName,
												sessionsTotal : this.state.totalSessions,
												log_in: true,
												sign_up: false,
												isLoginOpen: false,
												pickedSessions: [{
																	'hostName': this.state.allAboutSession.hostBy.firstName+' '+this.state.allAboutSession.hostBy.lastName,
																	'sessionStartTime': this.state.allAboutSession.sessionStartTime,
																	'duration': this.state.allAboutSession.duration,
																	'amount': fcfs,
																	'id': this.state.allAboutSession.id
																}]
											},()=>{
												
												$("#chargePopup").attr({'style':'display:block'})
											}
											);
									}
							}
						else
							{
								if ( this.state.allAboutSession.sessionChargeAllowed != 1 )
									{
										console.log('ELSE !$.isEmptyObject(object) || object !== null');
										this.closeLogin();
										this.openSignUp();
									}
								else
									{
										console.log('THISSSSSSSSSSSSS 1111');
										
										let pickedSessions = [{
																	'chargeForSession': this.state.chosenSession.chargeForSession,
																	'chargeForSessionNonMember': this.state.chosenSession.chargeForSessionNonMember,
																	'duration': this.state.chosenSession.duration,
																	'externFormatDate': this.state.chosenSession.sessionStartTime,
																	'hostFullName': this.state.chosenSession.hostBy.firstName+' '+this.state.chosenSession.hostBy.lastName,
																	'id': this.state.chosenSession.id,
																	'isCompleted': this.state.chosenSession.isCompleted,
																	'scheduleDate': this.state.chosenSession.scheduleDate,
																	'sdFormateDate': '',
																	'sessionEndDate': this.state.chosenSession.sessionEndDate,
																	'sessionProperty': this.state.chosenSession.sessionProperty
																}];
										let fcfs = this.calculatePrice( 0, pickedSessions);
										this.setState({
											isChargingSessionIncluded: true,
											chargeForSession: fcfs,
											finalChargeForSession: fcfs,
											sessionHostFirstName:  this.state.allAboutSession.hostBy.firstName,
											sessionHostLastName: this.state.allAboutSession.hostBy.lastName,
											sessionsTotal : this.state.totalSessions,
											log_in: false,
											sign_up: true,
											isLoginOpen: false,
											pickedSessions: [{
																'hostName': this.state.allAboutSession.hostBy.firstName+' '+this.state.allAboutSession.hostBy.lastName,
																'sessionStartTime': this.state.allAboutSession.sessionStartTime,
																'duration': this.state.allAboutSession.duration,
																'amount': fcfs,
																'id': this.state.allAboutSession.id
															}]
										},()=>{
											$("#chargePopup").attr({'style':'display:block'})
										}
										);
									}
							}
				  }
			else
				{
					if ( !$.isEmptyObject(object) )
						{
							axios.post(process.env.REACT_APP_NAME+"/api/v1/user/sendHostEmail",{"email_from": this.state.email , "email_to": this.state.hostEmail, "sessionId": this.state.chosenSession.id})
							.then(res => {
								$("#email_sent").attr({'style':'display:block'});
							});
						}
				}					
			
			let signEmail = this.state.email;
			
			this.setState({
						  firstName: '',
						  lastName: '',
						  email: '',
						  password: '',
						  rePassword: '',
						  emailSign: signEmail
						})
			
	  }
	
	$('.main_loader').hide();
}

export { channelCheckUser };